import React from 'react';
import { toast } from 'react-toastify';
import { ArcButton } from '@src/core/ui';
import {  useCancelMissionMutation } from '@src/features/order/redux';
import { CancelMissionOrderButtonProps } from './types';
import { trackError, toTrackedError } from '@src/core/sentry';

const CancelMissionOrderButton: React.FC<CancelMissionOrderButtonProps> = (props) => {
  const { missionId, successCallback } = props;
  const [cancelMission, { isLoading }] = useCancelMissionMutation();

  const onCancelGroupOrder = () => {
    cancelMission(missionId).unwrap().then(() => {
      successCallback?.();
      toast.success('Order has been successfully canceled');
    }).catch((err: unknown) => {
      trackError(toTrackedError(err), { code: 'FE_0020', extra: { flow: 'cancelMissionOrderButton' } });
    });
  };

  return (
    <ArcButton.ghost 
      fullWidth 
      isLoading={isLoading} 
      onClick={onCancelGroupOrder}> 
      Cancel 
    </ArcButton.ghost>
  );
};   

export default CancelMissionOrderButton;